export default {"src":"/_next/static/media/4.c0676351.svg","height":15,"width":21,"blurWidth":0,"blurHeight":0};